import { Component, Input, OnInit } from '@angular/core';
import { PnNumberControlConfiguration } from './pn-number-control.configuration';

@Component({
  selector: 'pn-number-control',
  templateUrl: './pn-number-control.component.html',
  styleUrls: ['./pn-number-control.component.scss']
})
export class PnNumberControlComponent implements OnInit {

  @Input() configuration : PnNumberControlConfiguration | null = null

  constructor() { }

  ngOnInit() {
  }

}
